import * as angular from 'angular';

class PrintDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';

    readonly template = `
        <div class="fc-print" ng-transclude></div>
    `;
}

const PrintDirectiveFactory: angular.IDirectiveFactory = () => new PrintDirective();

export { PrintDirectiveFactory };
